import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="mx-auto text-center container h-[50vh] pt-[100px]">
      <div className="w-40 h-40 mx-auto mb-8">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 100 100" 
          className="document-fold"
        >
          {/* Left page */}
          <path 
            d="M20,20 L50,20 L50,90 L20,90 Z" 
            fill="none" 
            stroke="#4B5563" 
            strokeWidth="6"
            className="page-left"
          />
          {/* Right page */}
          <path 
            d="M50,20 L80,20 L80,90 L50,90 Z" 
            fill="none" 
            stroke="#4B5563" 
            strokeWidth="6"
            className="page-right"
          />
          {/* Content lines */}
          <line x1="28" y1="40" x2="42" y2="40" stroke="#4B5563" strokeWidth="4" strokeLinecap="round" className="content-left"/>
          <line x1="28" y1="55" x2="42" y2="55" stroke="#4B5563" strokeWidth="4" strokeLinecap="round" className="content-left"/>
          <line x1="28" y1="70" x2="42" y2="70" stroke="#4B5563" strokeWidth="4" strokeLinecap="round" className="content-left"/>
          
          <line x1="58" y1="40" x2="72" y2="40" stroke="#4B5563" strokeWidth="4" strokeLinecap="round" className="content-right"/>
          <line x1="58" y1="55" x2="72" y2="55" stroke="#4B5563" strokeWidth="4" strokeLinecap="round" className="content-right"/>
          <line x1="58" y1="70" x2="72" y2="70" stroke="#4B5563" strokeWidth="4" strokeLinecap="round" className="content-right"/>
        </svg>
        <style>{`
          @keyframes foldLeft {
            0%, 100% { transform: perspective(400px) rotateY(0deg); }
            50% { transform: perspective(400px) rotateY(-60deg); }
          }
          
          @keyframes foldRight {
            0%, 100% { transform: perspective(400px) rotateY(0deg); }
            50% { transform: perspective(400px) rotateY(60deg); }
          }
          
          .document-fold {
            transform-style: preserve-3d;
          }
          
          .page-left {
            transform-origin: center right;
            animation: foldLeft 3s ease-in-out infinite;
          }
          
          .page-right {
            transform-origin: center left;
            animation: foldRight 3s ease-in-out infinite;
          }
          
          .content-left {
            transform-origin: center right;
            animation: foldLeft 3s ease-in-out infinite;
          }
          
          .content-right {
            transform-origin: center left;
            animation: foldRight 3s ease-in-out infinite;
          }
        `}</style>
      </div>
      <h1 className="text-4xl font-bold mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-6">Страница не найдена</h2>
      <p className="text-gray-600 mb-8">
        Страница, которую вы ищете, не существует или была перемещена.
      </p>
      <Link 
        to="/" 
        className="text-blue-500 hover:text-blue-700 underline"
      >
        Вернуться на главную
      </Link>
    </div>
  );
}

export default NotFound; 